import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthApiService } from '../../services/core-api/auth.service';
import { AuthStore } from './auth.store';
import { AlertService } from '../../services/alert.service';
import { ILoginDto, ILoginResponseDto } from '@nft-folks/interfaces';
import { ViemService } from './viem.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(
    private authStore: AuthStore,
    private authApiService: AuthApiService,
    private alertService: AlertService,
    private web3authService: ViemService,
  ) {}

  login(credentials: ILoginDto) {
    return this.authApiService.login(credentials).pipe(
      map((resp: ILoginResponseDto) => {
        if (resp?.profile) {
          this.authStore.update((state) => resp);
          return resp;
        } else {
          if (resp.message) {
            this.alertService.warning(resp.message);
          }
          return throwError(() => new Error(resp.message as string));
        }
      }),
    );
  }

  logout(): void {
    this.authApiService.logout().pipe(take(1)).subscribe();
    this.web3authService.logOut();
    this.resetAuthState();
  }

  resetAuthState() {
    this.authStore.reset();
    // this.router.navigateByUrl('/login');
    window.location.reload();
  }
}
